const rootSubscribe = (store) => () => {};

export default rootSubscribe;
